import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    quizConf: null,
    errors:[],
    editMode:false,
  },
  actions,
  mutations,
  getters
};
